import IconAttachment from '@/assets/icons/icon-attachment.svg'
import { getMessageText } from '@/components/ui/table/utils/utils.ts'
import { Tooltip } from '@/components/ui/tooltip.tsx'
import type { MediaOption } from '@/modules/message/components/editor/fields/message-media-dropdown.tsx'
import { PlaceholderTextPreview } from '@/modules/message/components/placeholder/placeholder-text-preview.tsx'
import type { Message } from '@/modules/online-mass-messages/types.ts'

const MAX_DISPLAY_MEDIA_COUNT = 10

export const TooltipWithHoverList = ({
  messages,
  mediaOptions,
}: {
  messages: Message[]
  mediaOptions: MediaOption[]
}) => {
  const firstMessageText = getMessageText(messages[0], mediaOptions)
  const firstMessageMediaLength = messages[0]?.medias?.length ?? 0

  return (
    <Tooltip
      className="max-w-xs truncate p-1"
      content={
        <ol className="flex flex-col gap-2 text-left">
          {messages.map((message, index) => (
            <li
              key={message.id}
              className="flex items-center gap-2 truncate rounded-sm bg-secondary-50 p-2 text-title dark:bg-secondary-500"
            >
              <span className="rounded-sm bg-primary-500/20 p-0.5 px-1 py-0 tabular-nums text-primary-500">
                {index + 1}
              </span>
              <div className="flex w-full items-center justify-between gap-4">
                <span className="max-w-2xl truncate text-ellipsis p-1">
                  <PlaceholderTextPreview
                    text={getMessageText(message, mediaOptions)}
                    showTooltip={false}
                    className="text-sm"
                  />
                </span>
                {message.medias && message.medias?.length > 0 && (
                  <div className="relative">
                    <IconAttachment className="h-5 w-5 text-secondary-200" />
                    <span className="absolute -bottom-1.5 -right-1.5 h-3 w-3 rounded-full bg-danger-default text-center text-[10px] font-semibold tabular-nums leading-tight text-white">
                      {message.medias.length}
                    </span>
                  </div>
                )}
              </div>
            </li>
          ))}
        </ol>
      }
      align="start"
    >
      {firstMessageText ? (
        <PlaceholderTextPreview
          showTooltip={false}
          text={firstMessageText}
        />
      ) : (
        <div className="relative h-5 w-6">
          <IconAttachment className="h-5 w-5 text-secondary-200" />
          <span className="absolute -bottom-1 -right-0.5 h-3 w-3 rounded-full bg-danger-default text-center text-[8px] font-semibold tabular-nums leading-tight text-white">
            {firstMessageMediaLength > MAX_DISPLAY_MEDIA_COUNT
              ? '9+'
              : firstMessageMediaLength}
          </span>
        </div>
      )}
    </Tooltip>
  )
}
